<form [formGroup]="orgForm">
    <fieldset>
        <legend class="mb-1" mat-dialog-title>Edit Organization</legend>
        <div mat-dialog-content>
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input type="text" matInput formControlName="name" />

                <mat-error *ngIf="orgForm.controls['name'].hasError('required')">
                    Name is required
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Domain</mat-label>
                <input type="text" matInput formControlName="domain" autocomplete="off"/>

                <mat-error *ngIf="orgForm.controls['domain'].hasError('required')">
                    Domain is required
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Parent Domain</mat-label>
                <mat-select formControlName="parent" (selectionChange)="onDomainChange($event)"
                    (click)="searchOrgFocus()">
                    <div class="dropdown-search">
                        <input #orginput [(ngModel)]="searchOrgPipe" [ngModelOptions]="{standalone: true}" matInput
                            placeholder="Search Domain">
                    </div>
                    <div>
                        <mat-option *ngFor="let organization of this.filteredOrg | searchOrg : searchOrgPipe"
                            [value]="organization._id">
                            {{ organization.name }} ({{ (organization.role == 0? "Root": organization.role
                            == 1? "Master Msp":organization.role == 2? "Msp": organization.role == 3?
                            "Organization": "") }})
                        </mat-option>
                    </div>
                </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="isRootUser">
                <mat-label>Type</mat-label>

                <mat-select formControlName="role" [(ngModel)]="selectedRole" disabled="true">

                    <mat-option *ngIf="selectedRole == 1" [value]="1">
                        Master MSP
                    </mat-option>
                    <mat-option *ngIf="selectedRole == 2" [value]="2">
                        MSP
                    </mat-option>
                    <mat-option *ngIf="selectedRole == 3" [value]="3">
                        Organization
                    </mat-option>

                </mat-select>
            </mat-form-field>

            <section class="example-section" *ngIf="isRootUser">
                <mat-checkbox class="example-margin" [(ngModel)]="bPending" [ngModelOptions]="{standalone: true}"
                    ngDefaultControl (change)="loadData()">Add Pending Devices</mat-checkbox>
            </section>

            <mat-form-field *ngIf="bPending">
                <mat-label>Pending Devices</mat-label>
                <mat-select formControlName="pendings" multiple (click)="searchMacFocus()">
                    <div class="dropdown-search">
                        <input #macinput [(ngModel)]="searchPipe" [ngModelOptions]="{standalone: true}" matInput
                            placeholder="Search MAC Address">
                    </div>
                    <div>
                        <mat-option *ngFor="let pending of pendingList | searchMac : searchPipe" [value]="pending.mac">
                            {{pending.mac}}
                        </mat-option>
                    </div>
                </mat-select>
            </mat-form-field>        
            <section class="login-acl-section" *ngIf="canSetLoginAcl">
                <span class="login-acl-label">Login Access Control</span>
                <mat-checkbox [checked]="allowAllLoginSources"
                    (change)="onAllowAllLoginSourcesChange($event)">Allow All</mat-checkbox>                
            </section>

            <div class="text-warning mb-2" *ngIf="canSetLoginAcl && !allowAllLoginSources">
                Warning: Allow All is off. Add CIDR/IP entries below to control login access.
            </div>
           
            <mat-form-field *ngIf="canSetLoginAcl && !allowAllLoginSources">
                <mat-label>Allowed Login CIDRs</mat-label>
                <textarea matInput rows="4" formControlName="loginAclAllowedCidrs" (input)="onLoginAclCidrsInput()"
                    placeholder="203.0.113.10&#10;198.51.100.0/24"></textarea>
                <mat-error *ngIf="orgForm.controls['loginAclAllowedCidrs'].hasError('loginAclCidrs')">
                    Enter valid IPv4 addresses or CIDR ranges
                </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="canSetLoginAcl && !allowAllLoginSources">
                <mat-label>Denied Login CIDRs</mat-label>
                <textarea matInput rows="4" formControlName="loginAclDeniedCidrs" (input)="onLoginAclCidrsInput()"
                    placeholder="198.51.100.25&#10;203.0.113.0/24"></textarea>
                <mat-error *ngIf="orgForm.controls['loginAclDeniedCidrs'].hasError('loginAclCidrs')">
                    Enter valid IPv4 addresses or CIDR ranges
                </mat-error>
            </mat-form-field>
        </div>
        <div mat-dialog-actions style="float: right;">
            <button mat-raised-button color="primary" class=" btn btnn" (click)="onSubmit()">Save</button>
            <button mat-raised-button color="warn" class=" btnn" (click)="onNoClick()">Cancel</button>
        </div>
    </fieldset>
</form>
